export const SET_COMPANY_LOGO = 'SET_COMPANY_LOGO';

export const setCompanyLogo = (id) => {
    return {
        type: SET_COMPANY_LOGO,
        payload: id
    }
}